import { HttpResponse, delay, http } from 'msw';

export const getProcessOcrInvoiceInferencesMock = () => {
  return {
    ap_instant_payee: {
      bank_branch: {},
      id: 'hmph',
      name: 'whoa',
    },
    ap_payee: {
      code: 'before',
      name: 'rope',
      default_cr_item: {
        display_name: 'rabbi',
        id: 'next',
      },
      default_cr_sub_item: {
        id: 'yippee',
      },
      default_cr_sub_item_id: null,
      default_ex_item: {
        id: 'sequence',
      },
      default_ex_item_id: null,
      default_name: null,
      default_project_code: {},
      display_name: 'refresh',
      id: 'from',
      payment_method: 'payment_slip',
    },
    invoice_registration_number: 'boo',
    invoice_transactions: [
      {
        cr_sub_item: {
          name: 'fav',
        },
        currency: 'excitedly',
        dept: {},
        dr_excise: {},
        excise_value: 1941650213437440,
        id: 'masterpiece',
        invoice_kind: 'unfortunately',
        jpyrate: 6427603720208384,
        memo: 'as',
        name: 'grateful',
        number: 'jealous',
        total_value: 6629159671431168,
        unit_value: 6802612261224448,
      },
      {
        ap_payee_type: 'against',
        cr_item: {},
        cr_sub_item: {
          id: 'antique',
        },
        currency: 'plough',
        dr_excise: {
          id: 'provided',
        },
        ex_item: {
          id: 'permit',
          name: 'austere',
        },
        excise_value: 6523953155670016,
        invoice_kind: 'ha',
        memo: 'motion',
        project_code: {
          name: 'although',
        },
        total_value: 5668253263200256,
        use_custom_jpy_rate: true,
        withholding_income_tax_value: 3531813035180032,
      },
      {
        ap_report_id: 'squatter',
        cr_item: {},
        cr_sub_item: {},
        deal_date: '2025-06-12',
        dr_excise: {
          name: 'alias',
        },
        invoice_kind: 'ack',
        jpyrate: 438032555573248,
        name: 'influence',
        project_code: {
          name: 'cushion',
        },
        quantity: 376995489775616,
        total_value: 3560005062098944,
        unit_value: 1162143651069952,
      },
      {
        ap_report_id: 'close',
        cr_sub_item: {
          id: 'beloved',
        },
        dr_excise: {
          id: 'wherever',
        },
        id: 'cosset',
        jpyrate: 1172231157710848,
        memo: 'who',
        number: 'aha',
        project_code: {
          id: 'nation',
          name: 'cruelly',
        },
        quantity: 9006279815069696,
        total_value: 6096729726255104,
        unit_value: 4009426753159168,
        use_custom_jpy_rate: true,
      },
      {
        ap_payee_type: 'aha',
        cr_item: {},
        currency: 'nor',
        ex_item: {
          name: 'duh',
        },
        excise_value: 5440433995907072,
        has_withholding_income_tax: false,
        jpyrate: 5616744106295296,
        project_code: {
          id: 'monthly',
          name: 'email',
        },
        quantity: 5443200563019776,
        total_value: 2875505072144384,
        use_custom_jpy_rate: true,
        withholding_income_tax_value: 4826402348072960,
      },
      {
        ap_report_id: 'ikebana',
        cr_item: {
          name: 'whereas',
        },
        dr_excise: {
          name: 'bean',
        },
        ex_item: {
          id: 'intently',
        },
        id: 'adjective',
        name: 'aw',
        project_code: {},
        quantity: 3899507267862528,
        use_custom_jpy_rate: false,
        withholding_income_tax_value: 3465168476438528,
      },
    ],
  };
};

export const handlers = [
  http.post('*/api/js/ocr_invoice_inferences', async () => {
    await delay(0);
    return new HttpResponse(
      JSON.stringify(getProcessOcrInvoiceInferencesMock()),
      {
        status: 200,
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
  }),
];

/*

    */
